import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, LoadingContainer } from '@redlink/components/atoms';

export const TwoColumnModalTemplate = memo(({ children, isBusy = false }) => {
  const { styles } = useStyle();
  return (
    <View style={[styles.mainContainer]}>
      <LoadingContainer {...{ isBusy }} style={styles.container}>
        <View style={styles.formContainer}>{children[0]}</View>
        <Space />
        <View style={styles.previewContainer}>{children[1]}</View>
      </LoadingContainer>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, height }) => ({
  mainContainer: {
    width: 750,
    height: height * 0.7,
    maxHeight: 600,
    backgroundColor: colors.gray22,
    borderRadius: 20,
    padding: 16,
    flexDirection: 'row',
  },
  container: {
    flexDirection: 'row',
  },
  mainContainerSoloColumn: {
    width: 450,
  },
  formContainer: {
    flex: 1,
  },
  previewContainer: {
    flex: 1,
  },
}));
